module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-1.7a03752a.png";